/*SYSTEM IMPORTS*/
    import React, { PureComponent } from 'react'
    // import c from 'classnames'

    import * as USER_TYPES from "constants/USER_TYPES"

    import { userName } from "helpers/SkinExpert"
    import { IsIsset } from "helpers/ValueTests"

    import Img from "components/Img"
    import Avatar from './Avatar'

    import ModeratorIcon from './images/photo-moderator-woman.svg'

    import { connect } from 'react-redux'
    
   class UserAvatar extends PureComponent {
        render() {
            const {
                id,
                avatar,
                user_type = USER_TYPES.TYPE_DOCTOR,
                isset_avatar = false,
                seo_alias = "",
                
                onlines = [],
                
                to = undefined,
                target = undefined,
                allowLink = false,
                className,
                children,
                onClick = undefined,
            } = this.props

            const online = onlines.includes( id )

            const name = userName( this.props )

            const link = !IsIsset( to ) &&
                         allowLink &&
                         user_type == USER_TYPES.TYPE_DOCTOR
                    ?
                        `/doctor/${seo_alias}`
                    :
                        to

            if( user_type == USER_TYPES.TYPE_MODERATOR )
            {
                return (
                    <Avatar
                        to={ link }
                        online={ online }
                        target={ target }
                        onClick={ onClick }
                        text={ name[0] }
                        name={ name }

                        image={ <Img src={ ModeratorIcon } div/> }
                        className={ className }
                    >
                        {children}
                    </Avatar>
                );
            } else if( user_type == USER_TYPES.TYPE_USER || !isset_avatar )
            {
                return (
                    <Avatar
                        to={ link }
                        online={ online }
                        target={ target }
                        onClick={ onClick }
                        text={ name[0] }
                        name={ name }
                    >
                        {children}
                    </Avatar>
                )
            } else
            {
                const image = <Img src={avatar} externals div/>

                return (
                    <Avatar
                        to={ link }
                        online={ online }
                        target={ target }
                        onClick={ onClick }
                        text={ name[0] }
                        name={ name }

                        image={ image }
                        className={ className }
                    >
                        {children}
                    </Avatar>
                );
            }
        }
    }

export { UserAvatar }

export default connect(({ settings }) => ({
    onlines: settings.now_online
}))(UserAvatar)
